import type { EfaxProviderFacility } from '../../types/efax-provider-facility';
import { hasExtractedValue } from './efax-cell-utils';
import { MissingValue } from './MissingValue';

interface FacilityCellProps {
  facility: EfaxProviderFacility;
}

export const FacilityCell = ({ facility }: FacilityCellProps) => {
  if (!hasExtractedValue(facility.name)) {
    return <MissingValue />;
  }

  return (
    <div className="min-w-[220px]">
      <div className="font-medium">{facility.name}</div>
      <div className="text-muted-foreground text-xs">
        {hasExtractedValue(facility.type) ? facility.type : '—'}
      </div>
    </div>
  );
};
